"use strict";

angular.module('app.modals.sceneActionSceneSelect', [])

    .controller('sceneActionSceneSelectModalCtrl', ['$scope','close','API','f_User','Action',
        function ($scope,close,API,f_User,Action ) {
        $scope.Action = Action;
            $scope.close = function( a )
            {
                close( a );
            }

        }
    ])

    .factory('sceneActionSceneSelectModal', ['ModalService', '$q', function (ModalService, $q) {
        return function (Action) {
            return ModalService.showModal({
                templateUrl: "views/modals/sceneActionSceneSelect.html",
                controller: 'sceneActionSceneSelectModalCtrl',
                inputs : {
                    Action : Action
                }
            });
        }
    }]);